import store from "../store/index";
//-----------
// get races
//-----------
export default function getRaces() {
  const this_store = store;
  const races = this_store.getters["races/getRaces"]
  return races;
}
